import { QuestionnaireQueryParams } from 'src/types/questionnaire';
import api from './axiosConfig';

export const getAllCategories = async () => {
  try {
    const therapistId = localStorage.getItem('userId');
    const response = await api({
      method: 'get',
      url: `/v2/therapist/${therapistId}/questionnaires/categories`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const createCategory = async (categoryName: string) => {
  try {
    const therapistId = localStorage.getItem('userId');
    const response = await api({
      method: 'post',
      url: `/v2/therapist/${therapistId}/questionnaires/category`,
      data: {
        name: categoryName,
      },
    });
    return {
      data: response.data,
      error: false,
      message: 'Questionnaire Category was successfully created.',
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
      message:
        'Failed to create new Questionnaire Category, please try again later or contact support.',
    };
  }
};

export const deleteQuestionnaireCategory = async (categoryId: string, therapistId: string) => {
  try {
    const tempId = therapistId || localStorage.getItem('userId');

    await api({
      method: 'delete',
      url: `/v2/therapist/${tempId}/questionnaires/category/${categoryId}`,
    });

    return {
      error: false,
      message: 'Questionnaire Category was successfully deleted.',
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
      message:
        'Failed to delete Questionnaire Category, please try again later or contact support.',
    };
  }
};

export const getAllQuestionnaires = async () => {
  try {
    const therapistId = localStorage.getItem('userId');
    const response = await api({
      method: 'get',
      url: `/v2/therapist/${therapistId}/questionnaires`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getQuestionnaireResponses = async (clientId: string, therapistId: string) => {
  try {
    const tempId = therapistId || localStorage.getItem('userId');
    const response = await api({
      method: 'get',
      url: `/v2/therapist/${tempId}/client/${clientId}/questionnaireResponses`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getPaginatedQuestionnaires = async (data: QuestionnaireQueryParams): Promise<any> => {
  try {
    const therapistId = localStorage.getItem('userId');
    const response = await api({
      method: 'get',
      url: `v2/therapist/${therapistId}/questionnaires`,
      params: {
        ...data,
      },
    });
    return {
      error: false,
      data: response.data,
    };
  } catch (error) {
    console.error(error);
    return {
      error: true,
      data: { limit: 10, questionnaires: [], startFrom: 0, totalSessions: 0 },
      message: 'Failed to fetch sessions.',
    };
  }
};

export const getSpecificQuestionnaire = async (questionnaire_id: string) => {
  try {
    const therapistId = localStorage.getItem('userId');
    const response = await api({
      method: 'get',
      url: `/v2/therapist/${therapistId}/questionnaire/${questionnaire_id}`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const createQuestionnaire = async (questionnaire: any) => {
  try {
    const therapistId = localStorage.getItem('userId');
    const response = await api({
      method: 'post',
      url: `/v2/therapist/${therapistId}/questionnaire`,
      data: questionnaire,
    });

    return {
      data: response.data,
      error: false,
      message: 'Questionnaire was successfully created.',
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
      message: 'Failed to create new Questionnaire, please try again later or contact support.',
    };
  }
};

export const updateQuestionnaire = async (
  updatedQuestionnaire: any,
  questionnaire_id: string,
  therapistId: string
) => {
  try {
    const tempId = therapistId || localStorage.getItem('userId');
    const response = await api({
      method: 'put',
      url: `/v2/therapist/${tempId}/questionnaire/${questionnaire_id}`,
      data: updatedQuestionnaire,
    });
    return {
      data: response.data,
      error: false,
      message: 'Questionnaire was successfully updated.',
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
      message: 'Failed to update Questionnaire, please try again later or contact support.',
    };
  }
};

export const deleteQuestionnaire = async (questionnaire_id: string, therapistId: string) => {
  try {
    const tempId = therapistId || localStorage.getItem('userId');

    await api({
      method: 'DELETE',
      url: `/v2/therapist/${tempId}/questionnaire/${questionnaire_id}`,
    });
    return {
      error: false,
      message: 'Questionnaire was successfully deleted.',
    };
  } catch (e) {
    console.error(e);
    return {
      error: true,
      message: 'Failed to delete Questionnaire, please try again later or contact support.',
    };
  }
};
